import React from "react";

const LoginLoader = () => {
  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50"
    >
      <div className="bg-white/90 rounded-2xl shadow-xl p-6 flex flex-col items-center gap-4 w-[260px]">
        
        {/* Spinner */}
        <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin" />

        {/* Messages */}
        <div className="text-center">
          <p className="text-slate-800 text-sm sm:text-base font-semibold">
            Securely logging you in...
          </p>
          <p className="text-slate-500 text-xs sm:text-sm mt-1">
            Preparing your dashboard. Please wait.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginLoader;
